import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Spin } from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { asUsdPrice, asNumber } from "utils/text";

export default function SummaryView(props) {
  const myUser = useSelector((state) => state.auth.user);
  const [data, setData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const onGetData = (res) => {
    setIsLoading(false);
    setData(res.data);
  };

  const onFailData = () => {
    setIsLoading(false);
  };
  const loadData = () => {
    setIsLoading(true);
    callGetApiWithAuth(
      `earning/summary?month=${props.selected.month}`,
      onGetData,
      onFailData
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Wrapper>
      <div className="modal-new-title">{`Earning Details (${props.selected.month})`}</div>
      {isLoading && (
        <div className="loadingRoot">
          <Spin spinning={true} />
        </div>
      )}
      {data && (
        <div>
          {data.caBonus && (
            <>
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <div>
                  <span className={"bonus-title"}>
                    Customer Aquisition Bonus
                  </span>
                  <span>&nbsp;</span>
                </div>
                <div>
                  <span
                    className={"detail-link"}
                    onClick={() => {
                      props.setBonusId(1);
                      props.setViewMode("detail");
                    }}
                  >
                    View Details
                  </span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.caBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.crBonus && (
            <>
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <div>
                  <span className={"bonus-title"}>
                    Customer Reorder Bonus
                  </span>
                  <span>&nbsp;</span>
                </div>
                <div>
                  <span
                    className={"detail-link"}
                    onClick={() => {
                      props.setBonusId(2);
                      props.setViewMode("detail");
                    }}
                  >
                    View Details
                  </span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.crBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.foBonus && (
            <>
              <div className="d-flex align-items-center flex-wrap">
                <div>
                  <span className={"bonus-title"}>
                    First Order Bonus
                  </span>
                  <span className="total-figure">
                    Total:&nbsp;{asUsdPrice(data.foBonus.total)}
                  </span>
                </div>
                <div>
                  <span
                    className={"detail-link"}
                    onClick={() => {
                      props.setBonusId(3);
                      props.setViewMode("detail");
                    }}
                  >
                    View Details
                  </span>
                </div>
              </div>
              <div className="table-container">
                <table className="level-table">
                  <thead>
                    {[...Array(2).keys()].map((index) => (
                      <th key={index} align={"center"}>
                        {`Level ${index + 1}`}
                      </th>
                    ))}
                  </thead>
                  <tbody>
                    <tr>
                      {data.foBonus.totalGrouped.map((el, index) => (
                        <td key={index} align={"center"}>
                          {el.amount > 0
                            ? `${asUsdPrice(el.amount)}/${asNumber(el.cv)}`
                            : "-"}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
          
          {data.tbBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Team Builder Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.tbBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.guBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Generational Unilevel Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.guBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.llBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Leadership Launch Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.llBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.spBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Silver Promo Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.spBonus.total)}</span>
                </div>
              </div>
            </>
          )}
           {data.cbBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Christmas Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.cbBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.bbBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>TBB Booster Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.bbBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.rsBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Rising Star Promo Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.rsBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.ssBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Sig Set Promo Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.ssBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.laBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Leadership Adjustment Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.laBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.spsBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Spring Surge Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.spsBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.egcBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Elevate Growth Challenge Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.egcBonus.total)}</span>
                </div>
              </div>
            </>
          )}
          {data.epsBonus && (
            <>
              <div className="d-flex align-items-center mb-1">
                <div>
                  <span className={"bonus-title"}>Elite Profit Sharing Bonus</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="price-tag">
                  Amount:&nbsp;
                  <span>{asUsdPrice(data.epsBonus.total)}</span>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .modal-new-title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #212b36;
    margin-bottom: 20px;
  }
  .loadingRoot {
    width: 100%;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-container {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 24px;
  }
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 8px;

    thead {
      th {
        :first-child {
          border-radius: 8px 0px 0px 0px;
        }
        :last-child {
          border-radius: 0px 8px 0px 0px;
        }
      }
    }
    tbody {
      tr {
        td {
          :first-child {
            border-radius: 0px 0px 0px 8px;
          }
          :last-child {
            border-radius: 0px 0px 8px 0px;
          }
        }
      }
    }

    th {
      position: relative;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      text-align: left;
      background: #fafafa;
      border: 1px solid #f2f2f2;
      transition: background 0.3s ease;
      padding: 4px 8px;
      text-align: center;
      font-size: 13px;
    }

    td {
      position: relative;
      text-align: center;
      border-bottom: 1px solid #f2f2f2;
      border-left: 1px solid #f2f2f2;
      border-right: 1px solid #f2f2f2;
      transition: background 0.3s;
      padding: 4px 0;
      color: #212b36;
      font-weight: 700;
    }
  }

  .level-table {
    width: 100%;
    @media (max-width: 1400px) {
      width: 1200px;
    }
  }
  .bonus-title {
    font-size: 16px;
    font-weight: 700;
    color: #212b36;
    margin-right: 24px;
  }
  .total-figure {
    margin-right: 24px;
    color: #637381;
  }
  .detail-link {
    color: #0ABAB5;
    cursor: pointer;
    font-size: 14px;
  }
  .price-tag {
    background: #f3f5f8;
    padding: 8px 16px;
    margin-right: 16px;
  }
`;